import React, { useState, useEffect } from 'react';
import { rulesApi } from '../api/rules';
import HrnbContainer, { HrnbRow, HrnbCol } from '../components/controls/HrnbContainer';
import HrnbCard from '../components/controls/HrnbCard';
import HrnbAlert from '../components/controls/HrnbAlert';
import HrnbLoader from '../components/controls/HrnbLoader';
import RuleCard from '../components/rules/RuleCard';

/**
 * Страница регламентов
 * Интеграция: rulesApi.listRegulations()
 */
export default function RegulationsPage() {
    const [regulations, setRegulations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchRegulations();
    }, []);

    const fetchRegulations = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await rulesApi.listRegulations();
            setRegulations(response.data || response.regulations || []);
        } catch (err) {
            setError(err.message || 'Ошибка при загрузке регламентов');
            setRegulations([]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <HrnbContainer className="regulations-page">
            <HrnbRow>
                <HrnbCol xs={12}>
                    <HrnbCard title="Регламенты" subtitle="Регламенты проведения баттлов">
                        <p className="regulations-page__intro">
                            Регламенты определяют процедуры и правила проведения различных типов баттлов.
                        </p>
                    </HrnbCard>
                </HrnbCol>
            </HrnbRow>

            <HrnbRow>
                <HrnbCol xs={12}>
                    {loading && (
                        <div className="regulations-page__loading">
                            <HrnbLoader />
                        </div>
                    )}

                    {error && (
                        <HrnbAlert variant="danger" onClose={() => setError(null)}>
                            {error}
                        </HrnbAlert>
                    )}

                    {!loading && !error && regulations.length === 0 && (
                        <HrnbAlert variant="info">
                            Регламенты отсутствуют.
                        </HrnbAlert>
                    )}

                    {!loading && !error && regulations.length > 0 && (
                        <div className="regulations-page__list">
                            {regulations.map((regulation) => (
                                <RuleCard 
                                    key={regulation.id} 
                                    rule={{
                                        ...regulation,
                                        title: regulation.title || 'Без названия',
                                        content: regulation.content || 'Нет описания',
                                        order: regulation.order,
                                        battleId: regulation.battleId
                                    }} 
                                />
                            ))}
                        </div>
                    )}
                </HrnbCol>
            </HrnbRow>
        </HrnbContainer>
    );
}
